<template>
    <v-dialog
        v-model="show"
        max-width="500"
    >
        <v-card>
            <v-card-title class="headline">{{ $translate('Waiting for payment confirmation') }}</v-card-title>

            <v-card-text>
                {{ $translate("We are in the process of confirming your Epassi payment, we'll notify you and you will receive an order confirmation via email shortly.") }}
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    color="primary"
                    @click="show = false"
                >
                    {{ $translate('Close') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { getUrlParamsStartingWith } from '../util.js';

export default {
    name: 'zoezi-epassi-redirect',

    data: () => ({
        show: false
    }),

    methods: {
        handleQueryParams(params) {
            if (params && params.epassi_status && params.epassi_transaction_id) {
                if (params.epassi_status == 'done') {
                    this.$api.get('/api/payment/epassi/order_confirmation', { transaction_id: params.epassi_transaction_id }).then((response) => {
                        if (response.status == 'pending') {
                            this.show = true;
                            let unsubscribeChannel = this.$api.subscribeChannel(response.channel2, (c2_resp) => {
                                if (c2_resp.type == 'payment') {
                                    if (c2_resp.success) {
                                        this.showCheckoutDoneDialog(c2_resp.orderconfirmation, response.amount);
                                    } else {
                                        this.$store.commit('showErrorDialog', {title: this.$translate('Payment failed'), text: this.$translate(c2_resp.message || 'Payment failed')});
                                    }
                                    unsubscribeChannel();
                                }
                            });
                        } else if (response.status == 'done') {
                            this.showCheckoutDoneDialog(response.orderconfirmation, response.amount);
                        } else if (response.status == 'failed') {
                            this.$store.commit('showErrorDialog', {title: this.$translate('Payment failed'), text: this.$translate(response.message || 'Payment failed')});
                        }

                        if ('epassi_cart' in params) {
                            this.$store.dispatch('removeCart', params.epassi_cart);
                        }
                    }).catch(() => {
                        this.$store.commit('showSnackBar', {text: this.$translate('Payment failed'), color: 'error'});
                    });
                } else if (params.epassi_status == 'cancelled') {
                    this.$store.commit('showSnackBar', {text: this.$translate('Payment cancelled'), color: 'warning'});
                } else if (params.epassi_status == 'rejected') {
                    this.$store.commit('showSnackBar', {text: this.$translate('Payment rejected'), color: 'error'});
                }
            }
        },
        getUrlParamsStartingWith,
        showCheckoutDoneDialog(orderConfirmation, amount) {
            this.$store.commit('showCheckoutDoneDialog', {orderconfirmation: orderConfirmation, totalFromServer: amount, paidByMethod: 'epassi', thankYouText: this.$translate('Thank you for your payment!')});
            this.show = false;
        },
    },
    mounted() {
        const queryParams = this.getUrlParamsStartingWith('epassi_', true);
        this.handleQueryParams(queryParams);
    }
}
</script>
